export class PaymentService {
    esignElectronicPrice: number = 20;
    esignDSCPrice: number = 20;
    esignAadhaarPrice: number = 30;
    estampPrice: number = 49;
    currencies: { code: string, symbol: string }[] = [
        { code: 'USD', symbol: '$' },
        { code: 'EUR', symbol: '€' },
        { code: 'GBP', symbol: '£' },
        { code: 'JPY', symbol: '¥' },
        { code: 'AUD', symbol: '$' },
        { code: 'CAD', symbol: '$' },
        { code: 'CNY', symbol: '¥' },
        { code: 'CHF', symbol: 'Fr' },
        { code: 'SEK', symbol: 'kr' },
        { code: 'NZD', symbol: '$' },
        { code: 'INR', symbol: '₹' }
    ];}
